import { apiClient } from '../utils/apiClient';

/**
 * One-time secret links (Secrets Vault). The payload arrives here already
 * encrypted (see utils/secretLinkCrypto.js) — this service only ever handles
 * ciphertext; the decryption key lives in the URL fragment and MUST NOT be
 * passed to (or through) these calls.
 */

/**
 * POST /secrets → { token, url, expires_at, max_views }.
 * The returned `url` has no key fragment — the caller appends `#k=...`.
 */
export async function createSecretLink({
  ciphertext,
  iv,
  alg,
  label,
  itemType,
  expiresInHours,
  maxViews,
}) {
  try {
    const body = { ciphertext, iv, alg, expires_in_hours: expiresInHours };
    if (label != null) body.label = label;
    if (itemType != null) body.item_type = itemType;
    if (maxViews != null) body.max_views = maxViews;

    const response = await apiClient.post('/secrets', body);
    return response.data; // { token, url, expires_at, max_views }
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to create secret link');
  }
}

/** DELETE /secrets/{token} — revoke (hard delete, creator only). */
export async function revokeSecretLink(token) {
  try {
    const response = await apiClient.delete(`/secrets/${token}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || 'Failed to revoke secret link');
  }
}

const secretLinkService = { createSecretLink, revokeSecretLink };
export default secretLinkService;
